import React from 'react';
import { Link } from 'react-router-dom';


import pr1 from 'images/d3.png';
import pr2 from 'images/d2.png';
import pr3 from 'images/d4.png';
import pr4 from 'images/d1.png';
import pr5 from 'images/d5.png';
import pr6 from 'images/d6.png';

const images = [
  { src: pr1, code: 'EB 2033 RE', link: '/products/2033' },
  { src: pr2, code: 'EB 2040 LV', link: '/products/2040' },
  { src: pr3, code: 'EB 2039 LV', link: '/products/2039' },
  { src: pr4, code: 'PBMR-1058', link: '/products/pbmr-1058' },
  { src: pr5, code: 'SMT-3021', link: '/products/smt-3021' },
  { src: pr6, code: 'ZN-1047', link: '/products/zn-1047' },
];

const Project = () => {
  return (
    <section className="relative mx-auto max-w-[1200px] justify-center md:mt-64 lg:mt-0 md:mb-0 mt-80  mb-0 w-full bg-white px-4 sm:px-6 lg:px-16">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 py-8">
          A Glimpse into Our Premium Laminates & Louvers
        </h2>
        <p className="text-gray-600 max-w-2xl mb-10 mx-auto text-sm md:text-base">
          A showcase of craftsmanship powered by Navkar's laminates. From durable core strength to flawless finishes, every detail reflects our commitment to quality and excellence.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {images.map((item, index) => (
          <div
            key={index}
            className="relative group rounded-lg overflow-hidden shadow-md w-full"
          >
            <img
              src={item.src}
              alt={`image${index + 1}`}
              className="w-full h-60 sm:h-72 object-cover transform transition-transform duration-300 group-hover:scale-105"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition duration-300" />

            {/* Sliding Code + Link */}
            <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
              <div className="text-white text-center">
                <p className="text-lg font-bold mb-2">{item.code}</p>
                <Link
                  to={item.link}
                  className="inline-block bg-orange-800   font-Montserrat hover:bg-orange-900 text-white text-sm px-4 py-2 rounded transition"
                >
                  View Product
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Project;
